// this file is generated by update_shopify_store_data.py at 2026-06-22 20:32:37.956774
var courses = [];